import type {
  Answer,
  CoverageQuestionsState,
} from 'ts/types/coverage-questions.types';
import type {
  GetLocationByCoordinatesPayload,
  GetLocationPayload,
  GetSuggestionsPayload,
  MobilityContinuationPointsKey,
  SetLocationSelectedPayload,
} from 'ts/types/mobility-continuation.types';
import { createAction, getActionList } from './action-utils';
import {
  GET_SYNERGY_COVERAGE_QUESTIONS,
  GET_SYNERGY_COVERAGE_QUESTIONS_SUCCESS,
  MOBILITY_CONTINUATION_CLEAR,
  MOBILITY_CONTINUATION_GET_LOCATION_BY_COORDS,
  MOBILITY_CONTINUATION_GET_OPTION_LOCATION,
  MOBILITY_CONTINUATION_GET_PRODUCT_ID_AND_DISTANCE,
  MOBILITY_CONTINUATION_GET_SUGGESTIONS,
  MOBILITY_CONTINUATION_SELECT_OPTION,
  MOBILITY_CONTINUATION_SET_PRODUCT_ID,
  MOBILITY_CONTINUATION_SET_CONSENT,
  MOBILITY_CONTINUATION_SET_QUERY_ERROR,
  MOBILITY_CONTINUATION_SET_QUERY_RESULTS_FOR_DESTINATION,
  MOBILITY_CONTINUATION_SET_QUERY_RESULTS_FOR_START,
  REMOVE_SYNERGY_LAST_COVERAGE_QUESTION,
  SET_SYNERGY_COVERAGE_QUESTION_RESPONSE,
  SET_SYNERGY_COVERAGE_QUESTION_RESPONSE_SUCCESS,
  SET_SYNERGY_COVERAGE_QUESTION_RESPONSES_SUCCESS,
} from './types';

const actions = {
  getCoverageQuestions: () => createAction(GET_SYNERGY_COVERAGE_QUESTIONS, {}),
  goToPreviousQuestion: () =>
    createAction(REMOVE_SYNERGY_LAST_COVERAGE_QUESTION, {}),
  sendCoverageResponse: (data: Answer) =>
    createAction(SET_SYNERGY_COVERAGE_QUESTION_RESPONSE, data),
  /**
   * Internal function for setting Redux state
   */
  setCoverageQuestionsData: (data: Partial<CoverageQuestionsState>) =>
    createAction(GET_SYNERGY_COVERAGE_QUESTIONS_SUCCESS, data),
  /**
   * Internal function for setting Redux state
   */
  setCoverageResponse: (data: CoverageQuestionsState['answers']) =>
    createAction(SET_SYNERGY_COVERAGE_QUESTION_RESPONSE_SUCCESS, data),
  /**
   * Internal function for setting Redux state
   */
  setCoverageResponses: (data: Answer[]) =>
    createAction(SET_SYNERGY_COVERAGE_QUESTION_RESPONSES_SUCCESS, data),
  getMobilityContinuationLocationByCoords: (
    payload: GetLocationByCoordinatesPayload,
  ) => createAction(MOBILITY_CONTINUATION_GET_LOCATION_BY_COORDS, payload),
  getMobilityContinuationLocationSelected: (payload: GetLocationPayload) =>
    createAction(MOBILITY_CONTINUATION_GET_OPTION_LOCATION, payload),
  setMobilityContinuationUpdateTemporalLocation: (
    payload: SetLocationSelectedPayload,
  ) => createAction(MOBILITY_CONTINUATION_SELECT_OPTION, payload),
  mobilityContinuationGetSuggestions: (payload: GetSuggestionsPayload) =>
    createAction(MOBILITY_CONTINUATION_GET_SUGGESTIONS, payload),
  clearMobilityContinuation: (payload: MobilityContinuationPointsKey) =>
    createAction(MOBILITY_CONTINUATION_CLEAR, payload),
  setMobilityContinuationQueryResultsForStart: (payload: any) =>
    createAction(MOBILITY_CONTINUATION_SET_QUERY_RESULTS_FOR_START, payload),
  setMobilityContinuationQueryResultsForDestination: (payload: any) =>
    createAction(
      MOBILITY_CONTINUATION_SET_QUERY_RESULTS_FOR_DESTINATION,
      payload,
    ),
  /**
   * Intended to use within Mobility Continuation's saga
   */
  setProductId: (value: string) =>
    createAction(MOBILITY_CONTINUATION_SET_PRODUCT_ID, value),
  setConsent: (value: boolean) =>
    createAction(MOBILITY_CONTINUATION_SET_CONSENT, value),
  getProductIdAndDistance: () =>
    createAction(MOBILITY_CONTINUATION_GET_PRODUCT_ID_AND_DISTANCE, {}),
  /**
   * Intended to use within Mobility Continuation's saga
   */
  setMobilityContinuationQueryError: (type: string) =>
    createAction(MOBILITY_CONTINUATION_SET_QUERY_ERROR, type),
};

export default actions;

const actionList = getActionList(actions);

export type MobilityContinuationActionType = typeof actionList[number];
